import { motion } from 'framer-motion';
import React, { useEffect, useRef } from 'react';

const SkillPopover = ({ details, position }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const popover = popoverRef.current;
    if (popover) {
      const rect = popover.getBoundingClientRect();
      const screenHeight = window.innerHeight;
      const screenWidth = window.innerWidth;
      
      // Adjust position if popover goes off screen
      let { x, y } = position;
      
      // Horizontal adjustment
      if (x + rect.width > screenWidth) {
        x = screenWidth - rect.width - 20;
      }
      
      // Vertical adjustment
      if (y + rect.height > screenHeight) {
        y = screenHeight - rect.height - 20;
      }

      popover.style.left = `${x}px`;
      popover.style.top = `${y}px`;
    }
  }, [position]);

  return (
    <motion.div
      ref={popoverRef}
      className="skill-popover"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.2 }}
    >
      {details && details.map((detail, index) => (
        <div key={index} className="skill-detail">
          <h4>{detail.title}</h4>
          <p>{detail.description}</p>
        </div>
      ))}
    </motion.div>
  );
};

export default SkillPopover;
